import { render, staticRenderFns } from "./CommonSlots.vue?vue&type=template&id=46d74d72"
import script from "./CommonSlots.vue?vue&type=script&lang=js"
export * from "./CommonSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports